var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayMobileAppBanner
    ? _c(
        "div",
        { staticClass: "mobile-app-banner" },
        [
          _c("CompassIconButton", {
            staticClass: "mobile-app-banner__close",
            attrs: { icon: "close", size: "small" },
            on: {
              click: function($event) {
                _vm.displayMobileAppBanner = false
              }
            }
          }),
          _vm._v(" "),
          _c("CompassObject", {
            staticClass: "mobile-app-banner__app",
            attrs: {
              label: _vm.$t.__("mobileApp.mobileAppBanner.app_name"),
              caption: _vm.$t.__(
                "mobileApp.mobileAppBanner.app_short_description"
              ),
              object: "logo",
              size: "large"
            }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            staticClass: "mobile-app-banner__button",
            attrs: {
              label: _vm.$t.__("mobileApp.mobileAppBanner.app_download")
            },
            on: { click: _vm.goToStore }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }